import {
  tag_styles_default
} from "./chunk.KPM2O54N.js";
import {
  SlTag
} from "./chunk.JBWO6I6I.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/tag/tag.ts
var FadvTag = class extends SlTag {
  render() {
    return $`<span part="base" class=${o({
      tag: true,
      "tag--primary": this.variant === "primary",
      "tag--secondary": this.variant.toString() === "secondary",
      "tag--tertiary": this.variant.toString() === "tertiary",
      "tag--success": this.variant === "success",
      "tag--neutral": this.variant === "neutral",
      "tag--warning": this.variant === "warning",
      "tag--danger": this.variant === "danger",
      "tag--text": this.variant === "text",
      "tag--small": this.size === "small",
      "tag--medium": this.size === "medium",
      "tag--large": this.size === "large",
      "tag--pill": this.pill,
      "tag--removable": this.removable
    })} ><span part="content" class="tag__content"><slot></slot></span>${this.removable ? $`<sl-icon-button part="remove-button" exportparts="base:remove-button__base" name="x" library="system" label=${this["localize"].term("remove")} class="tag__remove" @click=${this.handleRemoveClick} ></sl-icon-button>` : ""}</span>`;
  }
};
FadvTag.styles = tag_styles_default;
FadvTag = __decorateClass([
  n("fadv-tag")
], FadvTag);

export {
  FadvTag
};
